var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagUa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 548.69 398.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,20.54c168.49-71.15,367.35,71.17,536.08,0a1273.36,1273.36,0,0,1,12.61,178.8c-178.82,71.7-357.51-71.7-536.08,0A1273.36,1273.36,0,0,0,0,20.54Z",
    fill: "#005bbb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.61,199.34c178.57-71.7,357.27,71.7,536.08,0a1274.87,1274.87,0,0,1-12.61,178.8C347.18,449.29,188.66,307,0,378.14A1273.36,1273.36,0,0,0,12.61,199.34Z",
    fill: "#ffd500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUa);
export default __webpack_public_path__ + "static/media/flagUA.80d6e8efcfa1bea86ecc4bdbea4d0055.svg";
export { ForwardRef as ReactComponent };